<script lang="ts">
import { defineComponent, computed, PropType } from 'vue'
import { useMediaQueryStore } from '@/stores/mediaQuery'
import CarouselDefault from '@/components/carousel/CarouselDefault.vue'

/**
 * ホーム用カルーセル。
 * 実体は CarouselDefault のラッパーで、PC/モバイル出し分けに必要な設定値（phablet ブレークポイント由来）を渡すだけ。
 * マークアップ・スタイル・カルーセルロジックはすべて CarouselDefault が所有する。
 */
export default defineComponent({
  name: 'CarouselHome',

  components: {
    CarouselDefault,
  },

  props: {
    /** 表示するデータ配列。各スライドの中身は default slot で描画する */
    items: {
      type: Array as PropType<unknown[]>,
      default: () => [],
    },

    /** prev, next 制御ボタンを有効にする */
    enableNavigation: {
      type: Boolean,
      default: true,
    },

    /** インジケータ表示を有効にする */
    enableIndicator: {
      type: Boolean,
      default: true,
    },
  },

  setup(props) {
    const mediaQueryStore = useMediaQueryStore()

    // リアーキ後の基本ブレークポイントは phablet。phablet 以下でカルーセル、それ超で横並び。
    const isUnderPhablet = computed(() => mediaQueryStore.context.isUnderPhablet)

    // phablet 超: 全件を横並び（numberOfDisplayItems = 件数 → enableSlide=false でカルーセルしない）
    // phablet 以下: 1 件表示のループカルーセル
    const numberOfDisplayItems = computed(() => isUnderPhablet.value ? 1 : props.items.length)

    // Home 固有のデザイン値（phablet 以下 / 超 で切替）
    const slideGap = computed(() => isUnderPhablet.value ? 8 : 2)
    const peekRate = computed(() => isUnderPhablet.value ? 0.1 : 0)

    return {
      numberOfDisplayItems,
      slideGap,
      peekRate,
    }
  },
})
</script>

<template>
  <CarouselDefault
    :items="items"
    :number-of-display-items="numberOfDisplayItems"
    :enable-navigation="enableNavigation"
    :enable-indicator="enableIndicator"
    :slide-gap="slideGap"
    :peek-prev-rate="peekRate"
    :peek-next-rate="peekRate">
    <template #default="slotProps">
      <slot v-bind="slotProps" />
    </template>
  </CarouselDefault>
</template>
